// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-spark';

export const Component = () => (
  <path d='M21.71 6h-7v1h6.83l-6.82 7.25-2.96-3.46L3 18.45l.66.76 7.99-7 3.04 3.54 7.02-7.53V14h1V6z' />
);

export const viewBox = '0 0 25 25';
